import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  const serviceStrip = [
    'GST',
    'Income Tax',
    'TDS / TCS',
    'Professional Tax',
    'VAT',
    'ROC compliances',
    'NRI Taxation',
    'Statutory Audit',
    'Tax Audit',
    'GST Audit',
    'Internal Audit',
    'Stock Audits',
    'Certification of Investments & Debtors'
  ];

  const firmTimeline = [
    {
      year: '2012',
      text: 'Founded after qualifying from ICAI. Built the firm from the ground up in Mumbai.'
    },
    {
      year: '2015',
      text: 'Expanded services PAN India with associates.'
    },
    {
      year: '2026',
      text: 'Completed ICAI AI Certification course (Level 1). Successfully implemented AI in accounting and other work.'
    }
  ];

  const servedStates = [
    { name: 'Rajasthan', top: '36%', left: '35%' },
    { name: 'Gujarat', top: '49%', left: '24%' },
    { name: 'Maharashtra', top: '58%', left: '35%' },
    { name: 'Tamil Nadu', top: '84%', left: '44%' }
  ];

  const trustPoints = [
    {
      icon: 'speed',
      title: 'Zero Missed Deadlines',
      text: 'Not one filing deadline missed in 15+ years. Your ITR, GSTR, and ROC dates are our commitment.'
    },
    {
      icon: 'access',
      title: 'Direct CA Access',
      text: 'You speak to Ritesh Shah directly — not junior teams. Fast responses with actionable guidance.'
    },
    {
      icon: 'secure',
      title: 'Absolute Confidentiality',
      text: 'Your financial data remains protected with secure processes, restricted access, and NDA-first engagement.'
    },
    {
      icon: 'insight',
      title: 'Proactive Advisory',
      text: 'We identify tax-saving windows before they close and advise ahead of compliance deadlines.'
    }
  ];

  const industriesServed = [
    'Manufacturing',
    'Pharma & Healthcare',
    'Software & IT',
    'Service Industries',
    'Wholesalers',
    'Retailers'
  ];

  const renderTrustIcon = (type) => {
    if (type === 'speed') {
      return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M13 2L4 14H11L10 22L20 9H13L13 2Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        </svg>
      );
    }
    if (type === 'access') {
      return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M7 10C7 7.23858 9.23858 5 12 5C14.7614 5 17 7.23858 17 10" stroke="currentColor" strokeWidth="1.8" />
          <rect x="4" y="10" width="16" height="10" rx="3" stroke="currentColor" strokeWidth="1.8" />
          <path d="M12 13V17" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        </svg>
      );
    }
    if (type === 'secure') {
      return (
        <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M12 3L19 6V11.5C19 16 16.2 19.9 12 21C7.8 19.9 5 16 5 11.5V6L12 3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
          <path d="M9 12L11.2 14.2L15.5 9.9" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        </svg>
      );
    }
    return (
      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
        <path d="M12 3V5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M12 18.5V21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M5.6 5.6L7.3 7.3" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M16.7 16.7L18.4 18.4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M3 12H5.5" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M18.5 12H21" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <path d="M6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  };

  return (
    <div className="home">

      {/* HERO — Vailu-style abstract mosaic layout */}
      <section className="hero-vailu">

        <div className="hero-tagline-wrap">
          <h1 className="hero-tagline">
            Brains that lead the<br />
            Taxation, Audits,<br />
            Accountancy and Financing
          </h1>
        </div>

        {/* ROW 1 */}
        <div className="abstract-grid">

          <div className="abs-card abs-card--blue">
            <h3>Tax Compliances</h3>
            <ul className="abs-list">
              <li>GST</li>
              <li>Income Tax</li>
              <li>TDS / TCS</li>
              <li>Professional Tax</li>
              <li>VAT</li>
              <li>ROC compliances</li>
              <li>NRI Taxation</li>
            </ul>
          </div>

          <div className="abs-card abs-card--full-photo">
            <img src="/home1.jpeg" alt="Service 1" />
          </div>

          <div className="abs-card abs-card--dark">
            <h3>Audit &amp; Assurance</h3>
            <ul className="abs-list">
              <li>Statutory Audit</li>
              <li>Tax Audit</li>
              <li>GST Audit</li>
              <li>Internal Audit</li>
              <li>Stock Audits</li>
              <li>Certification of Investments &amp; Debtors</li>
            </ul>
          </div>

        </div>

        {/* ROW 2 */}
        <div className="abstract-grid abstract-grid--bottom">

          <div className="abs-card abs-card--full-photo">
            <img src="/home2.jpeg" alt="Service 2" />
          </div>

          <div className="abs-card abs-card--dark abs-card--tall">
            <h3 className="abs-red-headline">Other Services</h3>
            <ul className="abs-list">
              <li>Tax Planning</li>
              <li>Finance Planning</li>
              <li>Company Formation</li>
              <li>MIS Reporting</li>
              <li>Accounting Services</li>
              <li>ESIC, PF and Labour Law Related Services</li>
              <li>Company Law / ROC Related Services</li>
              <li>Consultancy</li>
            </ul>
          </div>

          <div className="abs-card abs-card--full-photo">
            <img src="/home3.jpeg" alt="Service 3" />
          </div>

        </div>

      </section>

      <section className="home-metrics-section" aria-label="Core services">
        <div className="home-services-strip" aria-label="Core services">
          <div className="home-services-track">
            {[...serviceStrip, ...serviceStrip].map((item, index) => (
              <span className="home-service-item" key={`${item}-${index}`}>
                {item}
              </span>
            ))}
          </div>
        </div>
      </section>

      <section className="about-firm-section">
        <div className="about-firm-grid">
          <aside className="about-firm-visual">
            <div className="about-firm-map-card about-firm-map-card--solo" aria-label="India map with served states">
              <img
                src="/india-map.png"
                alt="Map of India with state boundaries"
                className="about-firm-map-image"
              />
              {servedStates.map((state) => (
                <button
                  key={state.name}
                  type="button"
                  className="about-firm-state-pin"
                  style={{ top: state.top, left: state.left }}
                  aria-label={state.name}
                >
                  <span>{state.name}</span>
                </button>
              ))}
            </div>
          </aside>

          <div className="about-firm-content">
            <p className="about-firm-eyebrow">About the firm</p>
            <h2 className="about-firm-title">
              Built on trust,
              <span>driven by precision</span>
            </h2>
            <p className="about-firm-description">
              Established in 2012, Ritesh Shah &amp; Co. is a CA in practice based in Mumbai,
              built around one principle: every client deserves the clarity and proactiveness of
              an in-house solution for taxation, accounts, audits etc. We serve SMEs, startups,
              and HNIs across India.
            </p>

            <div className="about-firm-timeline">
              {firmTimeline.map((item) => (
                <article key={item.year} className="about-firm-timeline-item">
                  <span className="about-firm-year">{item.year}</span>
                  <p>{item.text}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="why-choose-section">
        <div className="container">
          <div className="why-choose-head">
            <p className="why-choose-eyebrow">Why choose us</p>
            <h2 className="why-choose-title">
              The Ritesh Shah &amp; Co.
              <span>difference</span>
            </h2>
          </div>

          <div className="why-choose-grid">
            {trustPoints.map((point) => (
              <article className="why-choose-item" key={point.title}>
                <span className="why-choose-icon" aria-hidden="true">{renderTrustIcon(point.icon)}</span>
                <h3>{point.title}</h3>
                <p>{point.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="client-stories-section">
        <div className="container">
          <div className="client-stories-head">
            <p className="client-stories-eyebrow">Industries We Serve</p>
            <h2 className="client-stories-title">Trusted by businesses across India</h2>
            <p className="client-stories-subtitle">
              From core operations to fast-growing ventures, we support diverse sectors with
              tailored taxation, compliance, audit, and advisory expertise.
            </p>
          </div>

          <div className="client-stories-industries">
            <div className="client-stories-industries-grid" aria-label="Industries served">
              {industriesServed.map((industry, index) => (
                <article className="client-industry-tile" key={industry}>
                  <span className="client-industry-badge" aria-hidden="true">
                    {String(index + 1).padStart(2, '0')}
                  </span>
                  <p>{industry}</p>
                </article>
              ))}
            </div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="cta-section">
        <div className="container">
          <h2>Ready to Connect?</h2>
          <p>Whether you need help with returns, compliance, or tax strategy, let's discuss what fits your goals.</p>
          <Link to="/contact" className="btn btn-primary">Get In Touch</Link>
        </div>
      </section>

      {/* Footer */}
      <section className="footer-section">
        <div className="container">
          <p>© 2026 Ritesh Shah &amp; Co. All rights reserved.</p>
          <p style={{ marginTop: '0.5rem', fontSize: '0.9rem', color: '#aaa' }}>
            Powered by{' '}
            <a
              href="https://elyspr.com/"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'none', fontWeight: 'bold' }}
            >
              Elyspr
            </a>
          </p>
        </div>
      </section>
    </div>
  );
};

export default Home;
